// extracted by mini-css-extract-plugin
module.exports = {"helpIcon":"HelpIcon_helpIcon__OnmFF"};